/* eslint-disable */
import React from 'react';
import {tagToChipColors} from "../../utils/CommonUtils";

const WebinarTags = ({tags, isModal}) => {
    if(!tags || tags.length === 0) return null;
    const classNames = isModal ? 'webinar-modal__tags' : 'webinar-card__tags';
    return (
        <div className={classNames}>
            {tags.map((tag, index) => (
                <span className="webinar-card__tag" key={`${tag}-${index}`} style={{
                    color: tagToChipColors(tag).color,
                    backgroundColor: tagToChipColors(tag).background
                }}>{tag}</span>
            ))}
        </div>
    )
}

export default WebinarTags;



// WEBPACK FOOTER //
// ./src/components/Webinars/WebinarTags.js